import {useEffect, type FC} from "react"
import {Box, Stack, Typography} from "@mui/material"
import {truncateText} from "../../../helpers/truncateText"
import EllipsisTypography from "../../atoms/customTypography/EllipsisTypography"
import {TruncatedTooltip} from "../../atoms/Tooltip"
import moment from "moment"
import {useSessionStorage} from "usehooks-ts"

type Props = {
  title: string
  subtitle: string
  date: string
}

const thoughtPieceItem: FC<Props> = (props) => {
  const {title, subtitle, date} = props

  const [language] = useSessionStorage("language", "en")
  useEffect(() => {
    if (language) {
      moment.locale(language)
    }
  }, [language])
  return (
    <Box
      id="moleculeThoughtPieceItemBox"
      style={{
        paddingLeft: "0px",
        marginLeft: "8px",
      }}
    >
      <Stack>
        <Box
          data-parent-hover={true}
          sx={{
            padding: "0px",
            textAlign: "start",
            color: "#242d35",
            fontWeight: 600,
            lineHeight: "1.43",
            marginBottom: "6px",
          }}
        >
          <EllipsisTypography
            text={title}
            lines={2}
            fontSize={14}
            tooltipComponent={TruncatedTooltip}
          />
        </Box>
        <Box
          style={{
            height: "10px",
            padding: "0px",
            fontSize: "12px",
            textAlign: "start",
            marginBottom: "8px",
            color: "#242d35",
            lineHeight: "1.33",
          }}
        >
          <Typography fontSize={12} id="atomThoughtPieceItemTextDate">
            {truncateText(
              moment(date).format("D MMM, YYYY").replace(".", ""),
              100,
              "...",
              true,
            )}
          </Typography>
        </Box>
        <Box
          style={{
            padding: "0px 6px 0px 0px",
            textAlign: "start",
            color: "#242d35",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            lineBreak: "normal",
            fontSize: "12px",
            WebkitBoxOrient: "vertical",
          }}
        >
          {subtitle}
        </Box>
      </Stack>
    </Box>
  )
}

export default thoughtPieceItem
